import { render, staticRenderFns } from "./SynergismSubtabBar.vue?vue&type=template&id=093e66f8&scoped=true&"
import script from "./SynergismSubtabBar.vue?vue&type=script&lang=js&"
export * from "./SynergismSubtabBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "093e66f8",
  null
  
)

export default component.exports